import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function Card({
  children,
  title,
  subtitle,
  actions,
  className,
  bodyClassName,
  noPadding = false,
}) {
  return (
    <div
      className={twMerge(
        clsx(
          'bg-white rounded-lg shadow-sm border border-gray-200',
          !noPadding && 'p-6'
        ),
        className
      )}
    >
      {(title || actions) && (
        <div className="flex items-center justify-between mb-4">
          <div>
            {title && (
              <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            )}
            {subtitle && (
              <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}

export function CardHeader({ children, className }) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between pb-4 border-b border-gray-200',
        className
      )}
    >
      {children}
    </div>
  );
}

export function CardBody({ children, className }) {
  return <div className={twMerge('py-4', className)}>{children}</div>;
}

export function CardFooter({ children, className }) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-end gap-3 pt-4 border-t border-gray-200',
        className
      )}
    >
      {children}
    </div>
  );
}

export default Card;
